<template>
  <v-btn
    :color="buttonColor"
    small
    dark
    @click="toggleStatus"
  >
    {{ buttonText }}
  </v-btn>
</template>

<script>
  export default {
    props: {
      initialStatus: {
        type: Boolean,
        required: true,
      },
      item: {
        type: Object,
        required: true,
      },
    },

    data () {
      return {
        isActive: this.initialStatus,
      }
    },

    computed: {
      buttonColor () {
        return this.isActive ? 'green' : 'red'
      },
      buttonText () {
        return this.isActive ? 'Ativo' : 'Inativo'
      },
    },

    watch: {
      initialStatus (newVal) {
        this.isActive = newVal
      },
    },

    methods: {
      toggleStatus () {
        this.isActive = !this.isActive
        this.$emit('changeStatus', { item: this.item, newStatus: this.isActive })
      },
    },
  }
</script>
